import { Compass } from "lucide-react"

import { Button } from "@/components/ui/button"
import logo from "../../asset/images/logo.png"

/**
 * 404 page with brand mark, compass illustration and a return-home action.
 *
 * @category Pages
 */
function NotFoundPage() {
  const handleGoHome = () => {
    window.location.assign("/")
  }

  return (
    <section className="flex min-h-screen flex-col items-center justify-center bg-muted p-6 text-center">
      <div className="w-full max-w-[480px] rounded-lg border border-border bg-background px-10 py-12 shadow-modal">
        <div className="flex flex-col items-center gap-1">
          <div className="mb-8">
            <img
              src={logo}
              alt="PlanOmatic logo"
              width="184"
              height="43"
            />
          </div>
          <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-secondary">
            <Compass className="h-7 w-7 text-muted-foreground" strokeWidth={1.5} />
          </div>
          <div className="mb-3">
            <h1 className="text-2xl font-medium text-foreground">
              Page Not Found
            </h1>
          </div>
          <div className="mb-8 leading-relaxed text-muted-foreground">
            <span className="text-base">
              The page you&apos;re looking for doesn&apos;t exist or may have
              been moved.
            </span>
          </div>
          <Button onClick={handleGoHome}>Go to Home</Button>
        </div>
      </div>
    </section>
  )
}

export default NotFoundPage
